import { useEffect } from 'react';
import { App as CapacitorApp } from '@capacitor/app';
import { useLocation, useNavigate } from 'react-router-dom';
import { isNativePlatform } from './capacitorPlatform';

const ROOT_ROUTES = new Set(['/login', '/dashboard']);

export default function NativeBackNavigation() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isNativePlatform()) {
            return undefined;
        }

        let listener;

        const register = async () => {
            listener = await CapacitorApp.addListener('backButton', () => {
                if (!ROOT_ROUTES.has(location.pathname) && window.history.length > 1) {
                    navigate(-1);
                    return;
                }

                if (location.pathname !== '/dashboard' && location.pathname !== '/login') {
                    navigate('/dashboard', { replace: true });
                    return;
                }
            });
        };

        void register();

        return () => {
            void listener?.remove();
        };
    }, [location.pathname, navigate]);

    return null;
}